import script from "./StandardA4X2NA.vue?vue&type=script&setup=true&lang=js"
export * from "./StandardA4X2NA.vue?vue&type=script&setup=true&lang=js"

import "./StandardA4X2NA.vue?vue&type=style&index=0&id=0bfb80f0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bfb80f0"]])

export default __exports__